var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTempRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 5.09375C10.5938 2.55488 8.53887 0.5 6 0.5C3.46113 0.5 1.40625 2.55488 1.40625 5.09375V11.9229C0.598242 12.9359 0.09375 14.1992 0.09375 15.5938C0.09375 18.8545 2.73926 21.5 6 21.5C9.26074 21.5 11.9062 18.8545 11.9062 15.5938C11.9062 14.1992 11.4018 12.9318 10.5938 11.9229V5.09375ZM6 18.875C4.19121 18.875 2.71875 17.4025 2.71875 15.5938C2.71875 14.5479 3.21914 13.5881 4.03125 12.977V5.09375C4.03125 4.00684 4.91309 3.125 6 3.125C7.08691 3.125 7.96875 4.00684 7.96875 5.09375V12.977C8.78086 13.584 9.28125 14.5479 9.28125 15.5938C9.28125 17.4025 7.80879 18.875 6 18.875ZM6.65625 13.7439V7.03625C6.65625 6.67531 6.36094 6.38 6 6.38C5.63906 6.38 5.34375 6.67531 5.34375 7.03625V13.7439C4.58086 14.0146 4.03125 14.7365 4.03125 15.5938C4.03125 16.6807 4.91309 17.5625 6 17.5625C7.08691 17.5625 7.96875 16.6807 7.96875 15.5938C7.96875 14.7365 7.41914 14.0146 6.65625 13.7439Z",
    fill: "#C82021"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTempRed);
export default __webpack_public_path__ + "static/media/icon-temp-red.ab4c11a8c4c8f40521b719a70ef56f3b.svg";
export { ForwardRef as ReactComponent };